// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "" + "936078205edeeb8b1a0d" + ".js";
};